import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'HomePage',
      component: () => import('@/pages/HomePage/index'),
      des: '电脑端宣传页'
    },
    {
      path: '/create',
      name: 'Create',
      component: () => import('@/pages/Create/index'),
      des: '电脑端创建页面'
    },
    {
      path: '/search/:id',
      name: 'Search',
      component: () => import('@/pages/Search/Index/index'),
      des: '电脑端搜索页面'
    },
    {
      path: '/create_mobile',
      name: 'CreateMobile',
      component: () => import('@/pages/CreateMobile/index'),
      des: '移动端创建页面'
    },
    {
      path: '/search_m/:id',
      name: 'SearchMobile',
      component: () => import('@/pages/SearchMobile/index'),
      des: '移动端搜索页面'
    },
    {
      path: '/homepage_m',
      name: 'HomepageMobile',
      component: () => import('@/pages/HomepageMobile/index'),
      des: '移动端宣传页面'
    },
    {
      path: '/profile_m/:id',
      name: 'ProfileMobile',
      component: () => import('@/pages/ProfileMobile/index'),
      des: '移动端编辑资料页面'
    },
    {
      path: '/notfound',
      name: 'notfound',
      component: () => import('@/pages/NotFound/index'),
      des: '404页面'
    },
    {
      path: '/bind_mobile/:id',
      name: 'BindMobile',
      component: () => import('@/pages/BindMobile/index'),
      des: '绑定手机并登陆页面'
    },
    {
      path: '/:id',
      name: 'Index',
      component: () => import('@/pages/Index/Index/index'),
      des: '主页页面'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js